export default "__VITE_ASSET__CJiJeY$k__"